import React, { useState, useEffect, useCallback } from 'react';
import { useAdmin } from '../context/AdminContext';

import { API } from '../config/api';
import { apiFetch } from '../config/http';

const LISTAS_META = [
    {
        key:         'categoria_proveedor',
        titulo:      'Categorías de proveedor',
        descripcion: 'Usado en: Proveedores',
        color:       '#185FA5',
        bg:          '#e6f1fb',
        icono:       '🏢',
    },
    {
        key:         'tipo_servicio',
        titulo:      'Tipos de servicio',
        descripcion: 'Usado en: Proyectos',
        color:       '#3B6D11',
        bg:          '#eaf3de',
        icono:       '🔧',
    },
    {
        key:         'tipologia',
        titulo:      'Tipologías de proyecto',
        descripcion: 'Usado en: Proyectos → Tipo de proyecto',
        color:       '#854F0B',
        bg:          '#faeeda',
        icono:       '🏗️',
    },
    {
        key:         'tipo_servicio_oferta',
        titulo:      'Tipos de servicio (Ofertas)',
        descripcion: 'Usado en: Ofertas a Clientes → Tipo de servicio',
        color:       '#533AB7',
        bg:          '#EEEDFE',
        icono:       '📋',
    },
    {
        key:         'gasto_medio_pago',
        titulo:      'Medios de pago (Gastos)',
        descripcion: 'Usado en: Gastos operativos → Medio de pago',
        color:       '#3B6D11',
        bg:          '#eaf3de',
        icono:       '💳',
    },
];

export default function Configuracion() {
    const isAdmin = useAdmin();

    const [listas, setListas]         = useState({});
    const [cargando, setCargando]     = useState(true);
    const [editando, setEditando]     = useState(null);
    const [nuevaLista, setNuevaLista] = useState('');
    const [nuevoValor, setNuevoValor] = useState('');
    const [guardando, setGuardando]   = useState(false);
    const [error, setError]           = useState('');

    // ── Email encargado facturación ─────────────────────────────────────────
    const [emailEncargado, setEmailEncargado]         = useState('');
    const [emailEditando, setEmailEditando]           = useState(false);
    const [emailTmp, setEmailTmp]                     = useState('');
    const [emailGuardando, setEmailGuardando]         = useState(false);
    const [emailMensaje, setEmailMensaje]             = useState('');

    useEffect(() => { cargar(); cargarConfig(); }, []);

    const cargar = async () => {
        setCargando(true);
        try {
            const res = await apiFetch(`${API}/listas`);
            if (!res.ok) throw new Error('Error al cargar');
            setListas(await res.json());
        } catch (e) {
            console.error(e);
            setError('No se pudieron cargar las listas. Verifica la conexión con la API.');
        }
        setCargando(false);
    };

    const cargarConfig = async () => {
        try {
            const res = await apiFetch(`${API}/configuracion`);
            if (!res.ok) return;
            const data = await res.json();
            const item = data.find(d => d.clave === 'email_encargado_facturacion');
            if (item) setEmailEncargado(item.valor || '');
        } catch { /* silencioso */ }
    };

    const guardarEmail = async () => {
        if (!emailTmp.trim()) return;
        setEmailGuardando(true); setEmailMensaje('');
        try {
            const res = await apiFetch(`${API}/configuracion`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ clave: 'email_encargado_facturacion', valor: emailTmp.trim() })
            });
            if (!res.ok) throw new Error('Error al guardar');
            setEmailEncargado(emailTmp.trim());
            setEmailEditando(false);
            setEmailMensaje('✓ Guardado correctamente');
            setTimeout(() => setEmailMensaje(''), 3000);
        } catch (e) { setEmailMensaje('⚠️ Error al guardar: ' + e.message); }
        finally { setEmailGuardando(false); }
    };

    const agregarItem = async (listaKey) => {
        if (!nuevoValor.trim()) return;
        setGuardando(true); setError('');
        try {
            const items = listas[listaKey] || [];
            const maxOrden = items.length > 0 ? Math.max(...items.map(i => i.orden)) : 0;
            const res = await apiFetch(`${API}/listas`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ lista: listaKey, valor: nuevoValor.trim(), orden: maxOrden + 1 })
            });
            const data = await res.json();
            if (!res.ok) { setError(data.error || 'Error al agregar'); return; }
            setNuevoValor('');
            setNuevaLista('');
            await cargar();
        } catch (e) { setError(e.message); }
        finally { setGuardando(false); }
    };

    const guardarEdicion = async () => {
        if (!editando?.valor?.trim()) return;
        setGuardando(true); setError('');
        try {
            const res = await apiFetch(`${API}/listas?id=${editando.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ lista: editando.lista, valor: editando.valor.trim(), orden: editando.orden })
            });
            const data = await res.json();
            if (!res.ok) { setError(data.error || 'Error al guardar'); return; }
            setEditando(null);
            await cargar();
        } catch (e) { setError(e.message); }
        finally { setGuardando(false); }
    };

    const eliminarItem = async (id) => {
        if (!window.confirm('¿Eliminar este valor de la lista? Esta acción no se puede deshacer.')) return;
        setError('');
        try {
            const res = await apiFetch(`${API}/listas?id=${id}`, { method: 'DELETE' });
            if (!res.ok) { setError('Error al eliminar'); return; }
            await cargar();
        } catch (e) { setError(e.message); }
    };

    // Acceso denegado si no es admin
    if (!isAdmin) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', fontFamily: 'Segoe UI, sans-serif' }}>
                <div style={{ textAlign: 'center', color: '#888' }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#012E40' }}>Acceso restringido</div>
                    <div style={{ fontSize: '13px', marginTop: '6px' }}>Esta sección es solo para administradores del sistema.</div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1100px' }}>

            {/* Header */}
            <div style={{ marginBottom: '24px' }}>
                <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#012E40', margin: 0 }}>
                    Configuración del sistema
                </h1>
                <p style={{ fontSize: '13px', color: '#888', margin: '6px 0 0' }}>
                    Listas desplegables y parámetros generales del sistema
                </p>
            </div>

            {/* ── Sección: Correos de notificación ── */}
            <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <div style={{ padding: '14px 16px', background: '#f0f7e8', borderBottom: '1px solid #e0e8d8', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '16px' }}>📧</span>
                    <div>
                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#3B6D11' }}>Correos de notificación</div>
                        <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>Destinatarios para alertas automáticas del sistema</div>
                    </div>
                </div>
                <div style={{ padding: '16px 18px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingBottom: '12px' }}>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '11px', color: '#888', fontWeight: '600', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Encargado de facturación
                            </div>
                            <div style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>
                                Recibe las solicitudes de factura generadas desde Cobros a Clientes
                            </div>
                            {emailEditando ? (
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <input
                                        autoFocus
                                        type='email'
                                        value={emailTmp}
                                        onChange={e => setEmailTmp(e.target.value)}
                                        onKeyDown={e => { if (e.key === 'Enter') guardarEmail(); if (e.key === 'Escape') setEmailEditando(false); }}
                                        style={{ flex: 1, padding: '7px 12px', border: '1px solid #87B749', borderRadius: '7px', fontSize: '13px', outline: 'none' }}
                                        placeholder='correo@dominio.com'
                                    />
                                    <button onClick={guardarEmail} disabled={emailGuardando}
                                        style={{ padding: '7px 16px', background: emailGuardando ? '#aaa' : '#3B6D11', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                                        {emailGuardando ? 'Guardando...' : 'Guardar'}
                                    </button>
                                    <button onClick={() => setEmailEditando(false)}
                                        style={{ padding: '7px 12px', background: 'none', border: '1px solid #ccc', borderRadius: '7px', fontSize: '12px', cursor: 'pointer', color: '#666' }}>
                                        Cancelar
                                    </button>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ background: '#f0f7e8', color: '#3B6D11', padding: '5px 14px', borderRadius: '8px', fontSize: '13px', fontWeight: '500', border: '1px solid #c8e6a0' }}>
                                        {emailEncargado || <span style={{ color: '#aaa', fontStyle: 'italic' }}>No configurado</span>}
                                    </span>
                                    <button onClick={() => { setEmailTmp(emailEncargado); setEmailEditando(true); }}
                                        style={{ padding: '5px 14px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '7px', fontSize: '12px', cursor: 'pointer' }}>
                                        Editar
                                    </button>
                                </div>
                            )}
                            {emailMensaje && (
                                <div style={{ marginTop: '8px', fontSize: '12px', color: emailMensaje.startsWith('✓') ? '#3B6D11' : '#A32D2D' }}>
                                    {emailMensaje}
                                </div>
                            )}
                        </div>
                    </div>
                    <div style={{ background: '#fffde6', border: '1px solid #f0d060', borderRadius: '7px', padding: '8px 12px', fontSize: '11.5px', color: '#7a5c00', display: 'flex', gap: '8px' }}>
                        <span>⚠️</span>
                        <span>Para que el envío de correos funcione, también deben estar configuradas las variables de entorno SMTP_HOST, SMTP_USER y SMTP_PASS en Azure Functions.</span>
                    </div>
                </div>
            </div>

            {/* Divisor */}
            <div style={{ marginBottom: '20px' }}>
                <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#012E40', margin: '0 0 4px' }}>Listas y Categorías</h2>
                <p style={{ fontSize: '12px', color: '#888', margin: 0 }}>Editar opciones de listas desplegables del sistema</p>
            </div>

            {/* Error global */}
            {error && (
                <div style={{ background: '#FCEBEB', border: '1px solid #f5c6c6', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', color: '#A32D2D' }}>
                    {error}
                </div>
            )}

            {/* Loading */}
            {cargando ? (
                <div style={{ textAlign: 'center', padding: '60px', color: '#888', fontSize: '14px' }}>
                    Cargando listas...
                </div>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '16px' }}>
                    {LISTAS_META.map(meta => {
                        const items = listas[meta.key] || [];
                        const estaAgregando = nuevaLista === meta.key;

                        return (
                            <div key={meta.key} style={{
                                background: '#fff',
                                border: '1px solid #e8e8e8',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.05)'
                            }}>
                                {/* Cabecera tarjeta */}
                                <div style={{
                                    padding: '14px 16px',
                                    background: meta.bg,
                                    borderBottom: '1px solid #e8e8e8',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <div>
                                        <div style={{ fontSize: '14px', fontWeight: '700', color: meta.color }}>
                                            {meta.icono} {meta.titulo}
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
                                            {meta.descripcion} · {items.length} valores
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => {
                                            setNuevaLista(estaAgregando ? '' : meta.key);
                                            setNuevoValor('');
                                            setEditando(null);
                                        }}
                                        style={{
                                            padding: '5px 12px',
                                            background: estaAgregando ? '#fff' : meta.color,
                                            color: estaAgregando ? meta.color : '#fff',
                                            border: `1px solid ${meta.color}`,
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {estaAgregando ? 'Cancelar' : '+ Agregar'}
                                    </button>
                                </div>

                                {/* Input agregar nuevo */}
                                {estaAgregando && (
                                    <div style={{ padding: '10px 14px', background: '#f9f9f9', borderBottom: '1px solid #eee', display: 'flex', gap: '8px' }}>
                                        <input
                                            autoFocus
                                            value={nuevoValor}
                                            onChange={e => setNuevoValor(e.target.value)}
                                            onKeyDown={e => e.key === 'Enter' && agregarItem(meta.key)}
                                            placeholder="Nuevo valor..."
                                            style={{
                                                flex: 1,
                                                padding: '7px 10px',
                                                border: `1px solid ${meta.color}`,
                                                borderRadius: '6px',
                                                fontSize: '13px',
                                                outline: 'none'
                                            }}
                                        />
                                        <button
                                            onClick={() => agregarItem(meta.key)}
                                            disabled={guardando || !nuevoValor.trim()}
                                            style={{
                                                padding: '7px 14px',
                                                background: meta.color,
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                opacity: guardando || !nuevoValor.trim() ? 0.6 : 1
                                            }}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                )}

                                {/* Lista de ítems */}
                                <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                                    {items.length === 0 ? (
                                        <div style={{ padding: '20px', textAlign: 'center', color: '#bbb', fontSize: '13px' }}>
                                            No hay valores. Agrega el primero.
                                        </div>
                                    ) : (
                                        items.map((item, idx) => {
                                            const esteEditando = editando?.id === item.id;
                                            return (
                                                <div key={item.id} style={{
                                                    padding: '10px 14px',
                                                    borderBottom: idx < items.length - 1 ? '1px solid #f3f3f3' : 'none',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    background: esteEditando ? '#fffde7' : 'transparent'
                                                }}>
                                                    {/* Número de orden */}
                                                    <span style={{
                                                        minWidth: '22px',
                                                        height: '22px',
                                                        background: meta.bg,
                                                        color: meta.color,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '10px',
                                                        fontWeight: '700',
                                                        flexShrink: 0
                                                    }}>
                                                        {idx + 1}
                                                    </span>

                                                    {/* Valor editable o texto */}
                                                    {esteEditando ? (
                                                        <input
                                                            autoFocus
                                                            value={editando.valor}
                                                            onChange={e => setEditando({ ...editando, valor: e.target.value })}
                                                            onKeyDown={e => {
                                                                if (e.key === 'Enter') guardarEdicion();
                                                                if (e.key === 'Escape') setEditando(null);
                                                            }}
                                                            style={{
                                                                flex: 1,
                                                                padding: '5px 8px',
                                                                border: `1px solid ${meta.color}`,
                                                                borderRadius: '5px',
                                                                fontSize: '13px',
                                                                outline: 'none'
                                                            }}
                                                        />
                                                    ) : (
                                                        <span style={{ flex: 1, fontSize: '13px', color: '#333' }}>
                                                            {item.valor}
                                                        </span>
                                                    )}

                                                    {/* Botones acción */}
                                                    <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                                                        {esteEditando ? (
                                                            <>
                                                                <button
                                                                    onClick={guardarEdicion}
                                                                    disabled={guardando}
                                                                    style={{
                                                                        padding: '3px 8px',
                                                                        background: meta.color,
                                                                        color: '#fff',
                                                                        border: 'none',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    ✓ Guardar
                                                                </button>
                                                                <button
                                                                    onClick={() => setEditando(null)}
                                                                    style={{
                                                                        padding: '3px 8px',
                                                                        background: 'none',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        cursor: 'pointer',
                                                                        color: '#666'
                                                                    }}
                                                                >
                                                                    Cancelar
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button
                                                                    onClick={() => {
                                                                        setEditando({ ...item, lista: meta.key });
                                                                        setNuevaLista('');
                                                                    }}
                                                                    style={{
                                                                        padding: '3px 8px',
                                                                        background: 'none',
                                                                        border: '1px solid #ddd',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        cursor: 'pointer',
                                                                        color: '#555'
                                                                    }}
                                                                >
                                                                    Editar
                                                                </button>
                                                                <button
                                                                    onClick={() => eliminarItem(item.id)}
                                                                    style={{
                                                                        padding: '3px 8px',
                                                                        background: 'none',
                                                                        border: '1px solid #fcc',
                                                                        borderRadius: '5px',
                                                                        fontSize: '11px',
                                                                        cursor: 'pointer',
                                                                        color: '#d32f2f'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
